export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 px-4 md:px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Bright%20airy%20modern%20retail%20concept%20with%20floating%20product%20displays%20on%20minimalist%20shelves%2C%20warm%20natural%20sunlight%20streaming%20through%20large%20windows%2C%20cream%20and%20terracotta%20interior%2C%20contemporary%20boutique%20aesthetic%2C%20clean%20organized%20composition%2C%20aspirational%20shopping%20experience%2C%20high%20detail%2C%20welcoming%20atmosphere&width=1600&height=700&seq=cta-bg-v2-2026&orientation=landscape"
          alt="Start smart shopping with Sugargoo Spreadsheet"
          title="Sugargoo Spreadsheet - Start Smart Shopping Today"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/40 via-foreground-950/30 to-foreground-950/40"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between gap-8 lg:gap-16">
          <div>
            <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-none">
              start smart
              <br />
              shopping
            </h2>
            <p className="mt-4 text-sm md:text-base text-background-50/80 max-w-md leading-relaxed">
              Ready to transform your shopping experience? Explore all product categories, discover the power of organized spreadsheets, and start saving on every order today.
            </p>
          </div>

          <div className="flex flex-col gap-3">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-between gap-4 px-6 py-3.5 bg-background-50 text-foreground-950 text-sm md:text-base font-semibold rounded-full hover:bg-background-100 transition-all cursor-pointer whitespace-nowrap min-w-[240px]"
            >
              Explore sugargoo spreadsheet
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-950">
                <i className="ri-arrow-right-line text-background-50 text-sm"></i>
              </span>
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center px-6 py-3 border-2 border-background-50/50 text-background-50 text-sm font-semibold rounded-full hover:bg-background-50 hover:text-foreground-950 transition-all cursor-pointer whitespace-nowrap"
            >
              Buy It Now
              <i className="ri-shopping-bag-line ml-2 text-lg"></i>
            </a>
          </div>
        </div>

        <div className="mt-14 flex flex-wrap gap-4">
          {["Shoes", "Hoodies", "T-Shirts", "Jackets", "Accessories", "Bags", "Jersey", "Sets"].map((tag) => (
            <a
              key={tag}
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="px-4 py-2 bg-background-50/10 backdrop-blur-sm border border-background-50/20 text-background-50 text-xs md:text-sm font-medium rounded-full hover:bg-background-50 hover:text-foreground-950 transition-all cursor-pointer whitespace-nowrap"
            >
              {tag}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}